var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { id: "card-zoom", type: "flex", justify: "center" } },
        [
          _c(
            "el-col",
            { staticClass: "flex-center", attrs: { span: 2 } },
            [
              _c(
                "el-button",
                { staticClass: "icon-button", on: { click: _vm.zoomOut } },
                [_c("i", { staticClass: "fal fa-search-minus color-white" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "flex-center", attrs: { span: 2 } },
            [
              _c("el-button", { attrs: { disabled: true } }, [
                _vm._v(
                  "\n        " + _vm._s(this.scaleZoomPorcentagem) + "%\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "flex-center", attrs: { span: 2 } },
            [
              _c(
                "el-button",
                { staticClass: "icon-button", on: { click: _vm.zoomIn } },
                [_c("i", { staticClass: "fal fa-search-plus color-white" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "flex-center", attrs: { span: 2 } },
            [
              _c(
                "el-button",
                { staticClass: "icon-button", on: { click: _vm.rotateLeft } },
                [_c("i", { staticClass: "fal fa-undo-alt color-white" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "flex-center", attrs: { span: 2 } },
            [
              _c(
                "el-button",
                { staticClass: "icon-button", on: { click: _vm.rotateRight } },
                [_c("i", { staticClass: "fal fa-redo-alt color-white" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "app-vue-perfect-scrollbar",
            { staticClass: "scroll-area", attrs: { settings: _vm.settings } },
            [
              _c("div", { attrs: { id: "image-container" } }, [
                _c("img", {
                  attrs: { id: "document-img-view", src: _vm.imgSrc }
                })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c4bf258", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c4bf258","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizarDocumentos/ImageViewer/ImageViewer.vue
// module id = null
// module chunks = 